// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * User profile left rail — light “settings” style (white panel, slate text, pill active).
 * Scoped to body.light_theme .profile-sidebar-shell
 */

.profile-sidebar-shell {
  position: relative;
}

/* Account rail: subtle left accent (reference dashboard sidebar) */
/* body.light_theme .profile-sidebar-shell.profile-sidebar-shell--dashboard {
  border-left: 3px solid #3b82f6;
} */

/* Wallet rail: same subtle accent */
/* body.light_theme .profile-sidebar-shell.profile-sidebar-shell--wallets {
  border-left: 3px solid #3b82f6;
} */

/* Rail width: smooth for light + dark */
.profile-sidebar-shell.leftside_menu {
  transition:
    width 0.4s cubic-bezier(0.4, 0, 0.2, 1),
    min-width 0.4s cubic-bezier(0.4, 0, 0.2, 1),
    max-width 0.4s cubic-bezier(0.4, 0, 0.2, 1),
    flex-basis 0.4s cubic-bezier(0.4, 0, 0.2, 1),
    padding 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.profile-sidebar-shell {
  box-sizing: border-box;
  width: 324px;
  min-width: 324px;
  max-width: 324px;
  flex: 0 0 324px;
}

.profile-sidebar-shell.profile-sidebar-shell--collapsed {
  width: 76px;
  min-width: 76px;
  max-width: 76px;
  flex: 0 0 76px;
  padding-left: 10px;
  padding-right: 10px;
}

/* Nav list */
.profile-sidebar-shell ul.navi_sidebar {
  max-width: none;
  gap: 8px;
}

/* Primary row: link */
.profile-sidebar-shell .navi_sidebar li a {
  border: 1px solid #ffffff00;
  padding: 14px 20px;
  gap: 14px !important;
  font-weight: 500;
  box-shadow: 0px 1px 3px #00000000;
  border-radius: 14px !important;
  font-size: 14px;
  margin: 0px;
  line-height: 1.35;
  align-items: center;
  display: flex;
  text-decoration: none;
  transition:
    background-color 0.15s ease,
    color 0.15s ease,
    padding 0.4s cubic-bezier(0.4, 0, 0.2, 1),
    gap 0.35s ease;
}

body.light_theme .profile-sidebar-shell .navi_sidebar li a {
  color: #303236;
}

.profile-sidebar-shell .navi_sidebar li a img,
.profile-sidebar-shell .navi_sidebar li a .deposit-sidebar-menu-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  object-fit: contain;
  display: block;
}

.profile-sidebar-shell .navi_sidebar li a .deposit-sidebar-menu-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: currentColor;
}

.profile-sidebar-shell .navi_sidebar li.deposit-sidebar-fiat-item {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

body.light_theme .profile-sidebar-shell .navi_sidebar li.deposit-sidebar-fiat-item {
  border-top-color: #e5e7eb;
}

body.light_theme .profile-sidebar-shell .navi_sidebar li.active a {
  background-color: #f2f3f7;
  border: 1px solid #dbdbdd;
  box-shadow: 0px 1px 3px #00000011;
}

body .profile-sidebar-shell ul.navi_sidebar {
  width: 250px;
}

body.light_theme .profile-sidebar-shell .navi_sidebar li.active .navi_sidebar_icon,
body.light_theme .profile-sidebar-shell .navi_sidebar li.active a .navi_sidebar_icon {
  color: #303236 !important;
}

/* Dropdown links: parent \`.active\` should not style every nested link */
body.light_theme .profile-sidebar-shell .navi_sidebar li.active ul.btn-toggle-nav li a {
  background-color: transparent;
  border-color: transparent;
  box-shadow: none;
}

/* Only the nested active item gets the active pill */
body.light_theme .profile-sidebar-shell .navi_sidebar li.active ul.btn-toggle-nav li.active a {
  background-color: #f2f3f7;
  /* border: 1px solid #DBDBDD; */
  box-shadow: 0px 1px 3px #00000011;
}

/* Accordion row: button */
.profile-sidebar-shell .navi_sidebar li button.btn-toggle {
  border: none !important;
  border-radius: 10px;
  padding: 14px 20px;
  gap: 12px;
  color: #e9e9e9;
  font-weight: 500;
  font-size: 14px;
  width: 100%;
  position: relative;
  transition:
    background-color 0.15s ease,
    color 0.15s ease,
    padding 0.4s cubic-bezier(0.4, 0, 0.2, 1),
    gap 0.35s ease;
}

body.light_theme .profile-sidebar-shell .navi_sidebar li button.btn-toggle {
  color: #303236;
}

/* body.light_theme .profile-sidebar-shell .navi_sidebar li button.btn-toggle:hover {
  background-color: #f8fafc !important;
  color: #334155 !important;
} */

/* body.light_theme .profile-sidebar-shell .navi_sidebar li:has(.dashboard_menu_hd.active_ul) button.btn-toggle {
  background-color: #f1f5f9 !important;
  color: #1e293b !important;
} */

/* body.light_theme .profile-sidebar-shell .navi_sidebar li:has(.dashboard_menu_hd.active_ul) .navi_sidebar_icon {
  color: #1e293b !important;
} */

body.light_theme .profile-sidebar-shell .navi_sidebar .navi_sidebar_icon {
  font-size: 20px;
  width: 22px;
  min-width: 22px;
  color: #64748b;
}

html[data-theme="dark"] body .profile-sidebar-shell .navi_sidebar img.navi_sidebar_icon {
  filter: brightness(0) invert(1) !important;
}

html[data-theme="dark"] body .profile-sidebar-shell .navi_sidebar i.navi_sidebar_icon {
  color: #fff !important;
}

body.light_theme .profile-sidebar-shell .navi_sidebar li.active .navi_sidebar_icon {
  color: #1e293b !important;
}

body.light_theme .profile-sidebar-shell .dashboard_menu_hd {
  color: inherit !important;
  font-weight: 500;
}

body.light_theme .profile-sidebar-shell .navi_sidebar li .dashboard_menu_hd.active_ul {
  color: #1e293b !important;
}

/* Labels + chevrons: animate width/opacity (avoid display:none snap) */
.profile-sidebar-shell .dashboard_menu_hd,
.profile-sidebar-shell .navi_sidebar li button>span:not(.navi_sidebar_icon) {
  overflow: hidden;
  white-space: nowrap;
  min-width: 0;
  max-width: 260px;
  opacity: 1;
  transition:
    max-width 0.42s cubic-bezier(0.4, 0, 0.2, 1),
    opacity 0.32s ease,
    margin 0.32s ease;
}

.profile-sidebar-shell.profile-sidebar-shell--collapsed .dashboard_menu_hd,
.profile-sidebar-shell.profile-sidebar-shell--collapsed .navi_sidebar li button>span:not(.navi_sidebar_icon) {
  max-width: 0;
  opacity: 0;
  margin: 0;
  pointer-events: none;
}

/* Chevron on section headers */
.profile-sidebar-shell .navi_sidebar li button span {
  right: 12px;
  color: #94a3b8;
}

/* Nested items */
/* body.light_theme .profile-sidebar-shell .navi_sidebar li ul {
  padding-left: 12px;
  padding-top: 6px;
  margin-top: 2px;
  border-left: 1px solid #e2e8f0;
  margin-left: 11px;
} */

/* Collapsed: icon-only (labels use max-width/opacity above) */
body.light_theme .profile-sidebar-shell.profile-sidebar-shell--collapsed .navi_sidebar li a,
body.light_theme .profile-sidebar-shell.profile-sidebar-shell--collapsed .navi_sidebar li button.btn-toggle {
  justify-content: center;
  padding-left: 10px;
  padding-right: 10px;
  flex-direction: column;
}

.profile-sidebar-shell.profile-sidebar-shell--collapsed .navi_sidebar li a .dashboard_menu_hd {
  display: none;
}

.profile-sidebar-shell.profile-sidebar-shell--collapsed .navi_sidebar li button .dashboard_menu_hd {
  display: none;
}

.profile-sidebar-shell.profile-sidebar-shell--collapsed .navi_sidebar li ul {
  display: none;
}

/* Collapse control — circle on the rail edge */
.profile-sidebar-collapse-btn {
  position: absolute;
  right: -18px;
  top: 40px;
  z-index: 668;
  width: 40px;
  height: 40px;
  border-radius: 50px;
  border: 1px solid #646464;
  background: #1d1d1d;
  /* box-shadow: 0 1px 4px rgba(15, 23, 42, 0.1); */
  display: none;
  color: #f4f4f4;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  transition:
    color 0.15s ease,
    box-shadow 0.15s ease,
    transform 0.15s ease;
}

body.light_theme .profile-sidebar-collapse-btn {
  color: #64748b;
  border: 1px solid #e2e8f0;
  background: #ffffff;
}

body.light_theme .profile-sidebar-collapse-btn:hover {
  color: #1e293b;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.12);
}

body.light_theme .profile-sidebar-collapse-btn i {
  font-size: 16px;
  line-height: 1;
}

@media (min-width: 992px) {
  .profile-sidebar-collapse-btn {
    display: flex;
  }
}

/* Logout — subtle footer strip */
body.light_theme .profile-sidebar-shell .logout_btn {
  width: calc(100% - 8px);
  max-width: 240px;
  margin-left: 0;
  border-top: 1px solid #e2e8f0;
  padding: 12px 0px;
  background: #fff;
}

body.light_theme .profile-sidebar-shell.profile-sidebar-shell--collapsed .logout_btn {
  width: 100%;
  max-width: none;
}

body.light_theme .profile-sidebar-shell .logout_btn a {
  background: transparent !important;
  color: #64748b !important;
  display: flex;
  padding: 0px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 500;
}

body.light_theme .profile-sidebar-shell .logout_btn a:hover {
  background: #f8fafc !important;
  color: #1e293b !important;
}

body.light_theme .profile-sidebar-shell .logout_btn a i {
  font-size: 18px;
}

/*
 * Profile layout: global .dashboard uses justify-content: space-between, which
 * shoves the main column to the far right (huge dead gap). Global .dashboard_right
 * also adds padding-left: 340px on top of the sidebar width — double offset.
 */
@media (min-width: 992px) {

  /*
   * Split scroll: rail scrolls inside its column; main content scrolls in .dashboard_right.
   * Lock .dashboard to viewport below header so overflow works (header ≈ 60px).
   */
  .dashboard {
    justify-content: flex-start;
    align-items: stretch;
    gap: 0;
    width: 100%;
    max-width: 100%;
    height: calc(100vh - 60px);
    min-height: calc(100vh - 60px);
    max-height: calc(100vh - 60px);
    overflow: hidden;
  }

  /* In-flow column: same height as row — do not use fixed (breaks layout) */
  .profile-sidebar-shell.leftside_menu {
    position: relative !important;
    top: auto;
    left: auto;
    bottom: auto;
    align-self: stretch;
    height: 100%;
    max-height: none;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overscroll-behavior: contain;
  }

  .profile-sidebar-shell ul.navi_sidebar {
    flex: 1 1 auto;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 0;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
  }

  .profile-sidebar-shell .logout_btn {
    position: relative !important;
    bottom: auto !important;
    left: auto !important;
    margin-top: auto;
    flex-shrink: 0;
    width: 100% !important;
    max-width: none !important;
    padding-bottom: max(12px, env(safe-area-inset-bottom, 0px));
  }

  /* Main column: own vertical scroll, independent of sidebar */
  .dashboard>.dashboard_right {
    flex: 1 1 !important;
    min-width: 0;
    min-height: 0;
    width: auto !important;
    max-width: none !important;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
  }

  /*
   * Dashboard two-column row: left had no flex-grow, so extra width sat on the RIGHT
   * (grey strip). Let the main stack grow; keep the widget rail at ~28%.
   */
  .dashboard .dashboard_listing_section {
    width: 100%;
    max-width: none;
    align-items: flex-start;
  }

  .dashboard .dashboard_left_side {
    flex: 1 1;
    min-width: 0;
    width: auto;
  }

  .dashboard .dashboard_right_side {
    /* flex: 0 0 27%; */
    width: 363px;
    max-width: 100%;
    min-width: 0;
  }

  /* Single-column listing sections (Overview, etc.): stretch the only block full width */
  .dashboard .dashboard_listing_section>*:only-child {
    flex: 1 1;
    min-width: 0;
  }
}

html.profile-sidebar--open,
body.profile-sidebar--open {
  overflow: hidden !important;
  height: 100% !important;
  height: 100vh !important;
  height: 100dvh !important;
  position: fixed !important;
  width: 100% !important;
  touch-action: none !important;
  overscroll-behavior: none !important;
  -webkit-overflow-scrolling: auto !important;
}

body.profile-sidebar--open .dashboard,
body.profile-sidebar--open .dashboard_right {
  overflow: hidden !important;
  touch-action: none !important;
}

@media (max-width: 991.98px) {
  body.light_theme .profile-sidebar-shell .navi_sidebar li.active a {
    background-color: #bdbdbd3d;
    border: 1px solid #dbdbdd00;
    box-shadow: 0px 1px 3px #00000000;
    color: #000000bd;
  }

  body.light_theme .dashboard {
    background-color: #fff;
  }

  /* Mobile / tablet: sidebar rail toggles via \`.leftside_menu.active\` (ProfilePage \`toggleContent\`) */
  body .mobile_view#toggleBtn,
  body .mobile_view.asset-sidebar-toggle {
    display: flex;
    margin-top: 0px;
    padding: 9px 15px;
    border-bottom: 1px solid #444c5b12;
  }

  /* Chevron on mobile menu bar: rotates when rail / overlay is open */
  body .mobile_view .mobile_view__chevWrap {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  body .mobile_view .mobile_view__chev {
    font-size: 24px;
    line-height: 1;
    transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);
    transform: rotate(0deg);
  }

  body .mobile_view.mobile_view--open .mobile_view__chev {
    transform: rotate(180deg);
  }

  .profile-sidebar-shell .navi_sidebar li button.btn-toggle {
    font-weight: 500;
    font-size: 16px;
    padding: 10px 15px;
  }

  body .mobile_view#toggleBtn,
  body .mobile_view.asset-sidebar-toggle {
    align-items: center;
    position: relative;
    color: #fff;
    z-index: 99;
    background-color: #1e222a;
  }

  .mobile_view img {
    filter: brightness(0) invert(1) !important;
  }

  body.light_theme .mobile_view img {
    filter: brightness(0) invert(0) !important;
  }

  body.light_theme .mobile_view#toggleBtn,
  body.light_theme .mobile_view.asset-sidebar-toggle {
    background-color: #fff;
    color: #000;
  }

  .profile-sidebar-shell {
    padding-top: 0px;
    top: 0px;
  }

  .dashboard {
    padding-top: 0px;
  }

  .profile-sidebar-shell .navi_sidebar li a {
    font-size: 15px;
    padding: 10px 15px;
  }

  body .profile-sidebar-shell ul.navi_sidebar {
    width: 100%;
    padding: 120px 20px 20px !important;
    z-index: 999;
  }

  .profile-sidebar-shell .logout_btn {
    max-width: 100% !important;
    width: calc(100% - 0px) !important;
  }

  .profile-sidebar-shell.leftside_menu {
    width: 100%;
    min-width: 0;
    max-width: 100%;
    flex: 0 0 auto;
    display: block;
    height: 100vh;
    position: fixed;
    inset: 0;
    z-index: 1;
    overflow: hidden;
    background: #181a20;
    transform: translateY(-100%);
    transition: transform 0.9s cubic-bezier(0.22, 1, 0.36, 1);
    will-change: transform;
    pointer-events: none;
  }

  body.light_theme .profile-sidebar-shell.leftside_menu {
    background: #fff;
  }

  .profile-sidebar-shell.leftside_menu.active {
    display: flex;
    flex-direction: column;
    transform: translateX(0);
    pointer-events: auto;
  }

  body .profile-sidebar-shell.leftside_menu.active ul.navi_sidebar {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
  }

  body .profile-sidebar-shell.leftside_menu.active .logout_btn {
    flex: 0 0 auto;
  }
}

/* Any theme: if a listing section has only one child, make it full width.
   \`.dashboard_listing_section\` is a flex row; with one child it can otherwise
   stay shrink-to-content and leave empty space on the right. */
.dashboard .dashboard_listing_section>*:only-child {
  flex: 1 1;
  min-width: 0;
  width: 100%;
}

/* Collapsed rail: icon-only + tighter main column (all themes, desktop) */
@media (min-width: 992px) {
  .profile-sidebar-shell.profile-sidebar-shell--collapsed.leftside_menu {
    width: 76px !important;
    min-width: 76px !important;
    max-width: 76px !important;
  }

  .dashboard .dashboard_right {
    transition: padding-left 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }

  /* .dashboard.dashboard--sidebar-collapsed .dashboard_right {
    padding-left: 96px !important;
  } */
}

.profile-sidebar-shell.profile-sidebar-shell--collapsed .navi_sidebar li a,
.profile-sidebar-shell.profile-sidebar-shell--collapsed .navi_sidebar li button.btn-toggle {
  justify-content: center;
  padding-left: 10px;
  padding-right: 10px;
}

.profile-sidebar-shell.profile-sidebar-shell--collapsed .navi_sidebar li ul {
  display: none !important;
}

.profile-sidebar-shell .logout_btn a {
  transition:
    font-size 0.35s cubic-bezier(0.4, 0, 0.2, 1),
    gap 0.3s ease;
}

.profile-sidebar-shell.profile-sidebar-shell--collapsed .logout_btn a {
  font-size: 0;
  gap: 0;
}

.profile-sidebar-shell.profile-sidebar-shell--collapsed .logout_btn a i {
  font-size: 18px;
  transition: font-size 0.28s ease 0.05s;
}

body .profile-sidebar-shell--collapsed.profile-sidebar-shell ul.navi_sidebar {
  width: auto;
}

@media (max-width: 767px) {

  body .mobile_view#toggleBtn,
  body .mobile_view.asset-sidebar-toggle {
    padding: 10px;
  }

  body .profile-sidebar-shell ul.navi_sidebar {
    padding: 110px 12px 20px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/ProfilePage/profile-sidebar.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,kBAAkB;AACpB;;AAEA,mEAAmE;AACnE;;GAEG;;AAEH,oCAAoC;AACpC;;GAEG;;AAEH,wCAAwC;AACxC;EACE;;;;;6CAK2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,eAAe;EACf,QAAQ;AACV;;AAEA,sBAAsB;AACtB;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,iCAAiC;EACjC,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB;;;;kBAIgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,wEAAwE;AACxE;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,qDAAqD;AACrD;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA,0BAA0B;AAC1B;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB;;;;kBAIgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;GAGG;;AAEH;;;GAGG;;AAEH;;GAEG;;AAEH;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uEAAuE;AACvE;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV;;;qBAGmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,oBAAoB;AACtB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,cAAc;AAChB;;AAEA,iBAAiB;AACjB;;;;;;GAMG;;AAEH,8DAA8D;AAC9D;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iDAAiD;EACjD,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV;;;wBAGsB;AACxB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,iCAAiC;AACjC;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;EAIE;AACF;;EAEE;;;IAGE;EACF;IACE,2BAA2B;IAC3B,oBAAoB;IACpB,MAAM;IACN,WAAW;IACX,eAAe;IACf,0BAA0B;IAC1B,8BAA8B;IAC9B,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA,0EAA0E;EAC1E;IACE,6BAA6B;IAC7B,SAAS;IACT,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,iCAAiC;IACjC,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;IAC7B,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,0BAA0B;IAC1B,2DAA2D;EAC7D;;EAEA,6DAA6D;EAC7D;IACE,oBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,4BAA4B;EAC9B;;EAEA;;;IAGE;EACF;IACE,WAAW;IACX,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,SAAY;IACZ,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,YAAY;EACd;;EAEA,uFAAuF;EACvF;IACE,SAAY;IACZ,YAAY;EACd;AACF;;AAEA;;EAEE,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,6BAA6B;EAC7B,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;;EAEE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE;IACE,2BAA2B;IAC3B,2BAA2B;IAC3B,iCAAiC;IACjC,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA,oGAAoG;EACpG;;IAEE,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,kCAAkC;EACpC;;EAEA,oEAAoE;EACpE;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,wDAAwD;IACxD,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;;IAEE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,mCAAmC;IACnC,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,kCAAkC;EACpC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;IACd,cAAc;IACd,aAAa;IACb,eAAe;IACf,QAAQ;IACR,UAAU;IACV,gBAAgB;IAChB,mBAAmB;IACnB,4BAA4B;IAC5B,yDAAyD;IACzD,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,4BAA4B;EAC9B;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;;+DAE+D;AAC/D;EACE,SAAY;EACZ,YAAY;EACZ,WAAW;AACb;;AAEA,0EAA0E;AAC1E;EACE;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;IACE,0DAA0D;EAC5D;;EAEA;;KAEG;AACL;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;;iBAEe;AACjB;;AAEA;EACE,YAAY;EACZ,MAAM;AACR;;AAEA;EACE,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE;;IAEE,aAAa;EACf;;EAEA;IACE,mCAAmC;EACrC;AACF","sourcesContent":["/**\n * User profile left rail — light “settings” style (white panel, slate text, pill active).\n * Scoped to body.light_theme .profile-sidebar-shell\n */\n\n.profile-sidebar-shell {\n  position: relative;\n}\n\n/* Account rail: subtle left accent (reference dashboard sidebar) */\n/* body.light_theme .profile-sidebar-shell.profile-sidebar-shell--dashboard {\n  border-left: 3px solid #3b82f6;\n} */\n\n/* Wallet rail: same subtle accent */\n/* body.light_theme .profile-sidebar-shell.profile-sidebar-shell--wallets {\n  border-left: 3px solid #3b82f6;\n} */\n\n/* Rail width: smooth for light + dark */\n.profile-sidebar-shell.leftside_menu {\n  transition:\n    width 0.4s cubic-bezier(0.4, 0, 0.2, 1),\n    min-width 0.4s cubic-bezier(0.4, 0, 0.2, 1),\n    max-width 0.4s cubic-bezier(0.4, 0, 0.2, 1),\n    flex-basis 0.4s cubic-bezier(0.4, 0, 0.2, 1),\n    padding 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.profile-sidebar-shell {\n  box-sizing: border-box;\n  width: 324px;\n  min-width: 324px;\n  max-width: 324px;\n  flex: 0 0 324px;\n}\n\n.profile-sidebar-shell.profile-sidebar-shell--collapsed {\n  width: 76px;\n  min-width: 76px;\n  max-width: 76px;\n  flex: 0 0 76px;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n/* Nav list */\n.profile-sidebar-shell ul.navi_sidebar {\n  max-width: none;\n  gap: 8px;\n}\n\n/* Primary row: link */\n.profile-sidebar-shell .navi_sidebar li a {\n  border: 1px solid #ffffff00;\n  padding: 14px 20px;\n  gap: 14px !important;\n  font-weight: 500;\n  box-shadow: 0px 1px 3px #00000000;\n  border-radius: 14px !important;\n  font-size: 14px;\n  margin: 0px;\n  line-height: 1.35;\n  align-items: center;\n  display: flex;\n  text-decoration: none;\n  transition:\n    background-color 0.15s ease,\n    color 0.15s ease,\n    padding 0.4s cubic-bezier(0.4, 0, 0.2, 1),\n    gap 0.35s ease;\n}\n\nbody.light_theme .profile-sidebar-shell .navi_sidebar li a {\n  color: #303236;\n}\n\n.profile-sidebar-shell .navi_sidebar li a img,\n.profile-sidebar-shell .navi_sidebar li a .deposit-sidebar-menu-icon {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n  object-fit: contain;\n  display: block;\n}\n\n.profile-sidebar-shell .navi_sidebar li a .deposit-sidebar-menu-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: currentColor;\n}\n\n.profile-sidebar-shell .navi_sidebar li.deposit-sidebar-fiat-item {\n  margin-top: 10px;\n  padding-top: 10px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\nbody.light_theme .profile-sidebar-shell .navi_sidebar li.deposit-sidebar-fiat-item {\n  border-top-color: #e5e7eb;\n}\n\nbody.light_theme .profile-sidebar-shell .navi_sidebar li.active a {\n  background-color: #f2f3f7;\n  border: 1px solid #dbdbdd;\n  box-shadow: 0px 1px 3px #00000011;\n}\n\nbody .profile-sidebar-shell ul.navi_sidebar {\n  width: 250px;\n}\n\nbody.light_theme .profile-sidebar-shell .navi_sidebar li.active .navi_sidebar_icon,\nbody.light_theme .profile-sidebar-shell .navi_sidebar li.active a .navi_sidebar_icon {\n  color: #303236 !important;\n}\n\n/* Dropdown links: parent `.active` should not style every nested link */\nbody.light_theme .profile-sidebar-shell .navi_sidebar li.active ul.btn-toggle-nav li a {\n  background-color: transparent;\n  border-color: transparent;\n  box-shadow: none;\n}\n\n/* Only the nested active item gets the active pill */\nbody.light_theme .profile-sidebar-shell .navi_sidebar li.active ul.btn-toggle-nav li.active a {\n  background-color: #f2f3f7;\n  /* border: 1px solid #DBDBDD; */\n  box-shadow: 0px 1px 3px #00000011;\n}\n\n/* Accordion row: button */\n.profile-sidebar-shell .navi_sidebar li button.btn-toggle {\n  border: none !important;\n  border-radius: 10px;\n  padding: 14px 20px;\n  gap: 12px;\n  color: #e9e9e9;\n  font-weight: 500;\n  font-size: 14px;\n  width: 100%;\n  position: relative;\n  transition:\n    background-color 0.15s ease,\n    color 0.15s ease,\n    padding 0.4s cubic-bezier(0.4, 0, 0.2, 1),\n    gap 0.35s ease;\n}\n\nbody.light_theme .profile-sidebar-shell .navi_sidebar li button.btn-toggle {\n  color: #303236;\n}\n\n/* body.light_theme .profile-sidebar-shell .navi_sidebar li button.btn-toggle:hover {\n  background-color: #f8fafc !important;\n  color: #334155 !important;\n} */\n\n/* body.light_theme .profile-sidebar-shell .navi_sidebar li:has(.dashboard_menu_hd.active_ul) button.btn-toggle {\n  background-color: #f1f5f9 !important;\n  color: #1e293b !important;\n} */\n\n/* body.light_theme .profile-sidebar-shell .navi_sidebar li:has(.dashboard_menu_hd.active_ul) .navi_sidebar_icon {\n  color: #1e293b !important;\n} */\n\nbody.light_theme .profile-sidebar-shell .navi_sidebar .navi_sidebar_icon {\n  font-size: 20px;\n  width: 22px;\n  min-width: 22px;\n  color: #64748b;\n}\n\nhtml[data-theme=\"dark\"] body .profile-sidebar-shell .navi_sidebar img.navi_sidebar_icon {\n  filter: brightness(0) invert(1) !important;\n}\n\nhtml[data-theme=\"dark\"] body .profile-sidebar-shell .navi_sidebar i.navi_sidebar_icon {\n  color: #fff !important;\n}\n\nbody.light_theme .profile-sidebar-shell .navi_sidebar li.active .navi_sidebar_icon {\n  color: #1e293b !important;\n}\n\nbody.light_theme .profile-sidebar-shell .dashboard_menu_hd {\n  color: inherit !important;\n  font-weight: 500;\n}\n\nbody.light_theme .profile-sidebar-shell .navi_sidebar li .dashboard_menu_hd.active_ul {\n  color: #1e293b !important;\n}\n\n/* Labels + chevrons: animate width/opacity (avoid display:none snap) */\n.profile-sidebar-shell .dashboard_menu_hd,\n.profile-sidebar-shell .navi_sidebar li button>span:not(.navi_sidebar_icon) {\n  overflow: hidden;\n  white-space: nowrap;\n  min-width: 0;\n  max-width: 260px;\n  opacity: 1;\n  transition:\n    max-width 0.42s cubic-bezier(0.4, 0, 0.2, 1),\n    opacity 0.32s ease,\n    margin 0.32s ease;\n}\n\n.profile-sidebar-shell.profile-sidebar-shell--collapsed .dashboard_menu_hd,\n.profile-sidebar-shell.profile-sidebar-shell--collapsed .navi_sidebar li button>span:not(.navi_sidebar_icon) {\n  max-width: 0;\n  opacity: 0;\n  margin: 0;\n  pointer-events: none;\n}\n\n/* Chevron on section headers */\n.profile-sidebar-shell .navi_sidebar li button span {\n  right: 12px;\n  color: #94a3b8;\n}\n\n/* Nested items */\n/* body.light_theme .profile-sidebar-shell .navi_sidebar li ul {\n  padding-left: 12px;\n  padding-top: 6px;\n  margin-top: 2px;\n  border-left: 1px solid #e2e8f0;\n  margin-left: 11px;\n} */\n\n/* Collapsed: icon-only (labels use max-width/opacity above) */\nbody.light_theme .profile-sidebar-shell.profile-sidebar-shell--collapsed .navi_sidebar li a,\nbody.light_theme .profile-sidebar-shell.profile-sidebar-shell--collapsed .navi_sidebar li button.btn-toggle {\n  justify-content: center;\n  padding-left: 10px;\n  padding-right: 10px;\n  flex-direction: column;\n}\n\n.profile-sidebar-shell.profile-sidebar-shell--collapsed .navi_sidebar li a .dashboard_menu_hd {\n  display: none;\n}\n\n.profile-sidebar-shell.profile-sidebar-shell--collapsed .navi_sidebar li button .dashboard_menu_hd {\n  display: none;\n}\n\n.profile-sidebar-shell.profile-sidebar-shell--collapsed .navi_sidebar li ul {\n  display: none;\n}\n\n/* Collapse control — circle on the rail edge */\n.profile-sidebar-collapse-btn {\n  position: absolute;\n  right: -18px;\n  top: 40px;\n  z-index: 668;\n  width: 40px;\n  height: 40px;\n  border-radius: 50px;\n  border: 1px solid #646464;\n  background: #1d1d1d;\n  /* box-shadow: 0 1px 4px rgba(15, 23, 42, 0.1); */\n  display: none;\n  color: #f4f4f4;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n  transition:\n    color 0.15s ease,\n    box-shadow 0.15s ease,\n    transform 0.15s ease;\n}\n\nbody.light_theme .profile-sidebar-collapse-btn {\n  color: #64748b;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n}\n\nbody.light_theme .profile-sidebar-collapse-btn:hover {\n  color: #1e293b;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.12);\n}\n\nbody.light_theme .profile-sidebar-collapse-btn i {\n  font-size: 16px;\n  line-height: 1;\n}\n\n@media (min-width: 992px) {\n  .profile-sidebar-collapse-btn {\n    display: flex;\n  }\n}\n\n/* Logout — subtle footer strip */\nbody.light_theme .profile-sidebar-shell .logout_btn {\n  width: calc(100% - 8px);\n  max-width: 240px;\n  margin-left: 0;\n  border-top: 1px solid #e2e8f0;\n  padding: 12px 0px;\n  background: #fff;\n}\n\nbody.light_theme .profile-sidebar-shell.profile-sidebar-shell--collapsed .logout_btn {\n  width: 100%;\n  max-width: none;\n}\n\nbody.light_theme .profile-sidebar-shell .logout_btn a {\n  background: transparent !important;\n  color: #64748b !important;\n  display: flex;\n  padding: 0px;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  font-weight: 500;\n}\n\nbody.light_theme .profile-sidebar-shell .logout_btn a:hover {\n  background: #f8fafc !important;\n  color: #1e293b !important;\n}\n\nbody.light_theme .profile-sidebar-shell .logout_btn a i {\n  font-size: 18px;\n}\n\n/*\n * Profile layout: global .dashboard uses justify-content: space-between, which\n * shoves the main column to the far right (huge dead gap). Global .dashboard_right\n * also adds padding-left: 340px on top of the sidebar width — double offset.\n */\n@media (min-width: 992px) {\n\n  /*\n   * Split scroll: rail scrolls inside its column; main content scrolls in .dashboard_right.\n   * Lock .dashboard to viewport below header so overflow works (header ≈ 60px).\n   */\n  .dashboard {\n    justify-content: flex-start;\n    align-items: stretch;\n    gap: 0;\n    width: 100%;\n    max-width: 100%;\n    height: calc(100vh - 60px);\n    min-height: calc(100vh - 60px);\n    max-height: calc(100vh - 60px);\n    overflow: hidden;\n  }\n\n  /* In-flow column: same height as row — do not use fixed (breaks layout) */\n  .profile-sidebar-shell.leftside_menu {\n    position: relative !important;\n    top: auto;\n    left: auto;\n    bottom: auto;\n    align-self: stretch;\n    height: 100%;\n    max-height: none;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    overscroll-behavior: contain;\n  }\n\n  .profile-sidebar-shell ul.navi_sidebar {\n    flex: 1 1 auto;\n    overflow-y: auto;\n    overflow-x: hidden;\n    min-height: 0;\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior: contain;\n  }\n\n  .profile-sidebar-shell .logout_btn {\n    position: relative !important;\n    bottom: auto !important;\n    left: auto !important;\n    margin-top: auto;\n    flex-shrink: 0;\n    width: 100% !important;\n    max-width: none !important;\n    padding-bottom: max(12px, env(safe-area-inset-bottom, 0px));\n  }\n\n  /* Main column: own vertical scroll, independent of sidebar */\n  .dashboard>.dashboard_right {\n    flex: 1 1 0% !important;\n    min-width: 0;\n    min-height: 0;\n    width: auto !important;\n    max-width: none !important;\n    overflow-y: auto;\n    overflow-x: hidden;\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior: contain;\n  }\n\n  /*\n   * Dashboard two-column row: left had no flex-grow, so extra width sat on the RIGHT\n   * (grey strip). Let the main stack grow; keep the widget rail at ~28%.\n   */\n  .dashboard .dashboard_listing_section {\n    width: 100%;\n    max-width: none;\n    align-items: flex-start;\n  }\n\n  .dashboard .dashboard_left_side {\n    flex: 1 1 0%;\n    min-width: 0;\n    width: auto;\n  }\n\n  .dashboard .dashboard_right_side {\n    /* flex: 0 0 27%; */\n    width: 363px;\n    max-width: 100%;\n    min-width: 0;\n  }\n\n  /* Single-column listing sections (Overview, etc.): stretch the only block full width */\n  .dashboard .dashboard_listing_section>*:only-child {\n    flex: 1 1 0%;\n    min-width: 0;\n  }\n}\n\nhtml.profile-sidebar--open,\nbody.profile-sidebar--open {\n  overflow: hidden !important;\n  height: 100% !important;\n  height: 100vh !important;\n  height: 100dvh !important;\n  position: fixed !important;\n  width: 100% !important;\n  touch-action: none !important;\n  overscroll-behavior: none !important;\n  -webkit-overflow-scrolling: auto !important;\n}\n\nbody.profile-sidebar--open .dashboard,\nbody.profile-sidebar--open .dashboard_right {\n  overflow: hidden !important;\n  touch-action: none !important;\n}\n\n@media (max-width: 991.98px) {\n  body.light_theme .profile-sidebar-shell .navi_sidebar li.active a {\n    background-color: #bdbdbd3d;\n    border: 1px solid #dbdbdd00;\n    box-shadow: 0px 1px 3px #00000000;\n    color: #000000bd;\n  }\n\n  body.light_theme .dashboard {\n    background-color: #fff;\n  }\n\n  /* Mobile / tablet: sidebar rail toggles via `.leftside_menu.active` (ProfilePage `toggleContent`) */\n  body .mobile_view#toggleBtn,\n  body .mobile_view.asset-sidebar-toggle {\n    display: flex;\n    margin-top: 0px;\n    padding: 9px 15px;\n    border-bottom: 1px solid #444c5b12;\n  }\n\n  /* Chevron on mobile menu bar: rotates when rail / overlay is open */\n  body .mobile_view .mobile_view__chevWrap {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  body .mobile_view .mobile_view__chev {\n    font-size: 24px;\n    line-height: 1;\n    transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);\n    transform: rotate(0deg);\n  }\n\n  body .mobile_view.mobile_view--open .mobile_view__chev {\n    transform: rotate(180deg);\n  }\n\n  .profile-sidebar-shell .navi_sidebar li button.btn-toggle {\n    font-weight: 500;\n    font-size: 16px;\n    padding: 10px 15px;\n  }\n\n  body .mobile_view#toggleBtn,\n  body .mobile_view.asset-sidebar-toggle {\n    align-items: center;\n    position: relative;\n    color: #fff;\n    z-index: 99;\n    background-color: #1e222a;\n  }\n\n  .mobile_view img {\n    filter: brightness(0) invert(1) !important;\n  }\n\n  body.light_theme .mobile_view img {\n    filter: brightness(0) invert(0) !important;\n  }\n\n  body.light_theme .mobile_view#toggleBtn,\n  body.light_theme .mobile_view.asset-sidebar-toggle {\n    background-color: #fff;\n    color: #000;\n  }\n\n  .profile-sidebar-shell {\n    padding-top: 0px;\n    top: 0px;\n  }\n\n  .dashboard {\n    padding-top: 0px;\n  }\n\n  .profile-sidebar-shell .navi_sidebar li a {\n    font-size: 15px;\n    padding: 10px 15px;\n  }\n\n  body .profile-sidebar-shell ul.navi_sidebar {\n    width: 100%;\n    padding: 120px 20px 20px !important;\n    z-index: 999;\n  }\n\n  .profile-sidebar-shell .logout_btn {\n    max-width: 100% !important;\n    width: calc(100% - 0px) !important;\n  }\n\n  .profile-sidebar-shell.leftside_menu {\n    width: 100%;\n    min-width: 0;\n    max-width: 100%;\n    flex: 0 0 auto;\n    display: block;\n    height: 100vh;\n    position: fixed;\n    inset: 0;\n    z-index: 1;\n    overflow: hidden;\n    background: #181a20;\n    transform: translateY(-100%);\n    transition: transform 0.9s cubic-bezier(0.22, 1, 0.36, 1);\n    will-change: transform;\n    pointer-events: none;\n  }\n\n  body.light_theme .profile-sidebar-shell.leftside_menu {\n    background: #fff;\n  }\n\n  .profile-sidebar-shell.leftside_menu.active {\n    display: flex;\n    flex-direction: column;\n    transform: translateX(0);\n    pointer-events: auto;\n  }\n\n  body .profile-sidebar-shell.leftside_menu.active ul.navi_sidebar {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow-y: auto;\n    overflow-x: hidden;\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior: contain;\n  }\n\n  body .profile-sidebar-shell.leftside_menu.active .logout_btn {\n    flex: 0 0 auto;\n  }\n}\n\n/* Any theme: if a listing section has only one child, make it full width.\n   `.dashboard_listing_section` is a flex row; with one child it can otherwise\n   stay shrink-to-content and leave empty space on the right. */\n.dashboard .dashboard_listing_section>*:only-child {\n  flex: 1 1 0%;\n  min-width: 0;\n  width: 100%;\n}\n\n/* Collapsed rail: icon-only + tighter main column (all themes, desktop) */\n@media (min-width: 992px) {\n  .profile-sidebar-shell.profile-sidebar-shell--collapsed.leftside_menu {\n    width: 76px !important;\n    min-width: 76px !important;\n    max-width: 76px !important;\n  }\n\n  .dashboard .dashboard_right {\n    transition: padding-left 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  }\n\n  /* .dashboard.dashboard--sidebar-collapsed .dashboard_right {\n    padding-left: 96px !important;\n  } */\n}\n\n.profile-sidebar-shell.profile-sidebar-shell--collapsed .navi_sidebar li a,\n.profile-sidebar-shell.profile-sidebar-shell--collapsed .navi_sidebar li button.btn-toggle {\n  justify-content: center;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.profile-sidebar-shell.profile-sidebar-shell--collapsed .navi_sidebar li ul {\n  display: none !important;\n}\n\n.profile-sidebar-shell .logout_btn a {\n  transition:\n    font-size 0.35s cubic-bezier(0.4, 0, 0.2, 1),\n    gap 0.3s ease;\n}\n\n.profile-sidebar-shell.profile-sidebar-shell--collapsed .logout_btn a {\n  font-size: 0;\n  gap: 0;\n}\n\n.profile-sidebar-shell.profile-sidebar-shell--collapsed .logout_btn a i {\n  font-size: 18px;\n  transition: font-size 0.28s ease 0.05s;\n}\n\nbody .profile-sidebar-shell--collapsed.profile-sidebar-shell ul.navi_sidebar {\n  width: auto;\n}\n\n@media (max-width: 767px) {\n\n  body .mobile_view#toggleBtn,\n  body .mobile_view.asset-sidebar-toggle {\n    padding: 10px;\n  }\n\n  body .profile-sidebar-shell ul.navi_sidebar {\n    padding: 110px 12px 20px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
